// extracted by mini-css-extract-plugin
export var csatScore = "_am-5";
export var header = "_am-1";
export var panelWrapper = "_am-2";
export var postPreview = "_am-3";
export var rightContent = "_am-0";
export var wrappingText = "_am-4";